import * as Yup from 'yup'
import i18n from '../../i18n'
import { VALIDATION, VALIDATION_MESSAGES } from '../../utils/translation-constants'
import config from 'custom/config/environment'
import validationConfig from 'custom/config/validation.config.json'
const internalBeneConfig = validationConfig['addBeneficiary']['internal']

export const AddBeneficiarySchema = Yup.object().shape({
  nickName: Yup.string().required().matches(new RegExp('^[a-zA-Z ]*$'), 'Text only'),
  accountNumber: Yup.string().required(),
  confirmAccountNumber: Yup.string()
    .oneOf([Yup.ref('accountNumber'), null])
    .required('Account confirm is required'),
  bank: Yup.string().required(),
  branch: Yup.string().required(),
  transferLimit: Yup.string().required(),
})

export const TransferSchema = Yup.object().shape({
  amount: Yup.string().required(),
  description: Yup.string(),
})

export const AddInternalBeneficiarySchema = Yup.object().shape({
  nickName: Yup.string()
    .required(i18n.t(VALIDATION_MESSAGES.INTERNAL_NICK_NAME))
    .matches(new RegExp('^[a-zA-Z0-9_]*$'), VALIDATION_MESSAGES.VALID_NICK_NAME)
    .min(2, i18n.t(VALIDATION_MESSAGES.INTERNAL_NICK_NAME_VALID))
    .max(20, i18n.t(VALIDATION_MESSAGES.INTERNAL_NICK_NAME_VALID)),
  accountNumber: Yup.string()
    .matches(
      new RegExp(config.ACC_NO_VALIDATION),
      i18n.t(VALIDATION_MESSAGES.INTERNAL_ACCOUNT_NO_MIN_MAX),
    )
    .required(i18n.t(VALIDATION_MESSAGES.INTERNAL_ACCOUNT_NO)),
  confirmAccountNumber: Yup.string()
    .oneOf(
      [Yup.ref('accountNumber'), null],
      i18n.t(VALIDATION_MESSAGES.INTERNAL_CONFIRM_ACCOUNT_NO_NOT_MATCH),
    )
    .required(i18n.t(VALIDATION_MESSAGES.INTERNAL_CONFIRM_ACCOUNT_NO)),
  maxTransferAmount: Yup.string().required(i18n.t(VALIDATION_MESSAGES.INTERNAL_TRANSFER_LIMIT)),
})

export const AddThirdPartyBeneficiarySchema = Yup.object().shape({
  benName: Yup.string()
    .required(i18n.t(VALIDATION_MESSAGES.DOMESTIC_BENEFICIARY_NAME))
    .min(2, i18n.t(VALIDATION_MESSAGES.DOMESTIC_BENEFICIARY_NAME_MIN_MAX))
    .max(32, i18n.t(VALIDATION_MESSAGES.DOMESTIC_BENEFICIARY_NAME_MIN_MAX)),
  nickName: Yup.string()
    .required(i18n.t(VALIDATION_MESSAGES.DOMESTIC_NICK_NAME))
    .matches(new RegExp('^[a-zA-Z0-9_]*$'), VALIDATION_MESSAGES.VALID_NICK_NAME)
    .min(2, i18n.t(VALIDATION_MESSAGES.DOMESTIC_NICK_NAME_MIN_MAX))
    .max(20, i18n.t(VALIDATION_MESSAGES.DOMESTIC_NICK_NAME_MIN_MAX)),
  accountNumber: Yup.string()
    .min(23, i18n.t(VALIDATION_MESSAGES.DOMESTIC_ACCOUNT_NUMBER_MIN_MAX))
    .max(23, i18n.t(VALIDATION_MESSAGES.DOMESTIC_ACCOUNT_NUMBER_MIN_MAX))
    .required(i18n.t(VALIDATION_MESSAGES.DOMESTIC_ACCOUNT_NUMBER)),
  confirmAccountNumber: Yup.string()
    .oneOf(
      [Yup.ref('accountNumber'), null],
      i18n.t(VALIDATION_MESSAGES.DOMESTIC_CONFIRM_ACCOUNT_NUMBER_NOT_MATCH),
    )
    .required(i18n.t(VALIDATION_MESSAGES.DOMESTIC_CONFIRM_ACCOUNT_NUMBER)),
  maxTransferAmount: Yup.string().required(i18n.t(VALIDATION_MESSAGES.DOMESTIC_TRANSFER_LIMIT)),
  bankName: Yup.string().required(i18n.t(VALIDATION_MESSAGES.DOMESTIC_BENEFICIARY_BANK)),
  // As client raised this we have hide this only for Domsatic NF2-I382
  // branchName:
  //   config.BENE_BRANCH &&
  //   Yup.string().required(i18n.t(VALIDATION_MESSAGES.DOMESTIC_BENEFICIARY_BRANCH)),
  beneEMail: Yup.string()
    .email(i18n.t(VALIDATION_MESSAGES.DOMESTIC_BENEFICIARY_EMAIL_PATTERN))
    .required(i18n.t(VALIDATION_MESSAGES.DOMESTIC_BENEFICIARY_EMAIL)),
  beneMobileNo: Yup.string().required(i18n.t(VALIDATION_MESSAGES.DOMESTIC_BENEFICIARY_MOBILE)),
})

export const AddRegionalBeneficiarySchema = Yup.object().shape({
  benName: Yup.string()
    .required(i18n.t(VALIDATION_MESSAGES.REGIONAL_BENEFICIARY_NAME))
    .min(2, i18n.t(VALIDATION_MESSAGES.REGIONAL_BENEFICIARY_NAME_MIN_MAX))
    .max(32, i18n.t(VALIDATION_MESSAGES.REGIONAL_BENEFICIARY_NAME_MIN_MAX)),
  nickName: Yup.string()
    .required(i18n.t(VALIDATION_MESSAGES.REGIONAL_NICK_NAME))
    .matches(new RegExp('^[a-zA-Z0-9_]*$'), VALIDATION_MESSAGES.VALID_NICK_NAME)
    .min(2, i18n.t(VALIDATION_MESSAGES.REGIONAL_NICK_NAME_MIN_MAX))
    .max(20, i18n.t(VALIDATION_MESSAGES.REGIONAL_NICK_NAME_MIN_MAX)),
  accountNumber: Yup.string()
    .min(5, i18n.t(VALIDATION_MESSAGES.REGIONAL_ACCOUNT_NUMBER_MIN_MAX))
    .max(20, i18n.t(VALIDATION_MESSAGES.REGIONAL_ACCOUNT_NUMBER_MIN_MAX))
    .required(i18n.t(VALIDATION_MESSAGES.REGIONAL_ACCOUNT_NUMBER)),
  confirmAccountNumber: Yup.string()
    .oneOf(
      [Yup.ref('accountNumber'), null],
      i18n.t(VALIDATION_MESSAGES.REGIONAL_CONFIRM_ACCOUNT_NUMBER_NOT_MATCH),
    )
    .required(i18n.t(VALIDATION_MESSAGES.REGIONAL_CONFIRM_ACCOUNT_NUMBER)),
  maxTransferAmount: Yup.string().required(i18n.t(VALIDATION_MESSAGES.REGIONAL_TRANSFER_LIMIT)),
  bankName: Yup.string().required(i18n.t(VALIDATION_MESSAGES.REGIONAL_BENEFICIARY_BANK)),
  branchName:
    config.BENE_BRANCH &&
    Yup.string().required(i18n.t(VALIDATION_MESSAGES.REGIONAL_BENEFICIARY_BRANCH)),
  beneEMail: Yup.string()
    .email(i18n.t(VALIDATION_MESSAGES.REGIONAL_BENEFICIARY_EMAIL_PATTERN))
    .required(i18n.t(VALIDATION_MESSAGES.REGIONAL_BENEFICIARY_EMAIL)),
  beneMobileNo: Yup.string().required(i18n.t(VALIDATION_MESSAGES.REGIONAL_BENEFICIARY_MOBILE)),
})

export const AddInternationalBeneficiarySchema = Yup.object().shape({
  benName: Yup.string()
    .matches(new RegExp('^[a-zA-Z ]*$'), 'Text only')
    .required(i18n.t(VALIDATION.BENEFICIARYNAME))
    .min(2, i18n.t(VALIDATION.BENEFICIARYNAMEVALID))
    .max(32, i18n.t(VALIDATION.BENEFICIARYNAMEVALID)),
  nickName: Yup.string()
    .required(i18n.t(VALIDATION_MESSAGES.INTERNAL_NICK_NAME))
    .matches(new RegExp('^[a-zA-Z0-9_]*$'), VALIDATION_MESSAGES.VALID_NICK_NAME)
    .min(2, i18n.t(VALIDATION_MESSAGES.INTERNAL_NICK_NAME_VALID))
    .max(20, i18n.t(VALIDATION_MESSAGES.INTERNAL_NICK_NAME_VALID)),
  accountNumber: Yup.string()
    .min(5, i18n.t(VALIDATION.ACCOUNTNOVALID1))
    .max(20, i18n.t(VALIDATION.ACCOUNTNOVALID1))
    .required(i18n.t(VALIDATION.ACCOUNTNO)),
  confirmAccountNumber: Yup.string()
    .oneOf([Yup.ref('accountNumber'), null], i18n.t(VALIDATION.CONFIRMACCOUNTNUMBERVALID))
    .required(i18n.t(VALIDATION.CONFIRMACCOUNTNUMBER)),
  maxTransferAmount: Yup.string().required(i18n.t(VALIDATION.TRANSFERLIMIT)),
  bankAddress: Yup.string().required( i18n.t(VALIDATION.BANK_ADDRESS)),
  beneCountry: Yup.string().required( i18n.t(VALIDATION.BENEFICIARIE_COUNTRY)),
  bankName: Yup.string().required(i18n.t(VALIDATION.BENIFICIARYBANK)),
  bankBranch: Yup.string().required(i18n.t(VALIDATION.BENIFICIARYBRANCH)),
  beneEMail: Yup.string()
    .email( i18n.t(VALIDATION.BENEFICIARY_EMAIL_VALID))
    .required( i18n.t(VALIDATION.BENEFICIARY_EMAIL)),
  beneMobileNo: Yup.string()
    .min(8, i18n.t(VALIDATION.MOBILENOVALID1))
    .max(15, i18n.t(VALIDATION.MOBILENOVALID1))
    .required( i18n.t(VALIDATION.BENE_MOBILENO)),
  bankCountry: Yup.string().required( i18n.t(VALIDATION.BANK_COUNTRY)),
  beneAddress: Yup.string().required( i18n.t(VALIDATION.ADDRESS)),
  code: Yup.string().required(i18n.t(VALIDATION.REQUIRED)),
  // code: Yup.string().when('modeofTransfer', {
  //   is: 'IFSC',
  //   then: Yup.string()
  //     .required('IFSC Code is required')
  //     .min(8, 'Should be minimum 8 and maximum 11 digits')
  //     .max(11, 'Should be minimum 8 and maximum 11 digits'),
  //   otherwise: Yup.string()
  //     .min(8, 'Should be minimum 8 and maximum 11 digits')
  //     .max(11, 'Should be minimum 8 and maximum 11 digits')
  //     .required('SWIFT/BIC Code is required'),
  // }),
})

export const FundTransfer = Yup.object().shape({
  transferAmount: Yup.string().required(i18n.t(VALIDATION.AMOUNT)),
  remarks: Yup.string().min(4, 'Minimum 4 Characters').required(i18n.t(VALIDATION.REMARKS)),
  transferType: Yup.string().required('TransferType is required'),
  //  showCurrency:Yup.boolean(),
  //  currency: Yup.string().when('showCurrency', {
  //   is: true,
  //   then: Yup.string().required('Please Select Currency'),
  //   otherwise: Yup.string(),
  // })
})

export const InternalTransferSchema = Yup.object().shape({
  transferAmount: Yup.string()
    // .matches(new RegExp('^[1-9][0-9]*$'), 'TransferAmount should not start with 0')
    .required(i18n.t(VALIDATION.TRANSFERAMOUNT)),
  remarks: Yup.string().min(4, i18n.t(VALIDATION_MESSAGES.MINIUM_CHAR)).required(i18n.t(VALIDATION.REMARKS)),
  txnCurrency: Yup.string().required(i18n.t(VALIDATION.currency)),
  customRemarks: Yup.string().when('remarks', {
    is: 'Custom',
    then: Yup.string().required(i18n.t(VALIDATION.CUSTOMTREMARK)),
    otherwise: Yup.string().optional(),
  }),
  isScheduled: Yup.string().required(i18n.t(VALIDATION.SCHUEDULETRANSFER)),

  scheduledDate: Yup.string().when('isScheduled', {
    is: 'Yes',
    then: Yup.string().required(i18n.t(VALIDATION.SCHEDULEDATE)),
    otherwise: Yup.string().optional(),
  }),
})

export const OtherTransferSchema = Yup.object().shape({
  transferAmount: Yup.string()
    // .matches(new RegExp('^[1-9][0-9]*$'), 'TransferAmount should not start with 0')
    .required(i18n.t(VALIDATION.TRANSFERAMOUNT)),
  remarks: Yup.string().required(i18n.t(VALIDATION.REMARKS)),
  customRemarks: Yup.string().when('remarks', {
    is: 'Custom',
    then: Yup.string().required(i18n.t(VALIDATION.CUSTOMTREMARK)),
    otherwise: Yup.string().optional(),
  }),
  isScheduled: Yup.string().required(i18n.t(VALIDATION.SCHUEDULETRANSFER)),

  scheduledDate: Yup.string().when('isScheduled', {
    is: 'Yes',
    then: Yup.string().required(i18n.t(VALIDATION.SCHEDULEDATE)),
    otherwise: Yup.string().optional(),
  }),
})

export const RegionalTransferSchema = Yup.object().shape({
  transferAmount: Yup.string()
    // .matches(new RegExp('^[1-9][0-9]*$'), 'TransferAmount should not start with 0')
    .required(i18n.t(VALIDATION.TRANSFERAMOUNT)),
  remarks: Yup.string().required(i18n.t(VALIDATION.REMARKS)),
  customRemarks: Yup.string().when('remarks', {
    is: 'Custom',
    then: Yup.string().required(i18n.t(VALIDATION.CUSTOMTREMARK)),
    otherwise: Yup.string().optional(),
  }),
  isScheduled: Yup.string().required(i18n.t(VALIDATION.SCHUEDULETRANSFER)),

  scheduledDate: Yup.string().when('isScheduled', {
    is: 'Yes',
    then: Yup.string().required(i18n.t(VALIDATION.SCHEDULEDATE)),
    otherwise: Yup.string().optional(),
  }),
})

export const InternationalTransferSchema = Yup.object().shape({
  transferAmount: Yup.string()
    // .matches(new RegExp('^[1-9][0-9]*$'), 'TransferAmount should not start with 0')
    .required(i18n.t(VALIDATION.TRANSFERAMOUNT)),
  fxRefNo: Yup.string().when('hasFxRefNo', {
    is: 'Y',
    then: Yup.string().required(i18n.t(VALIDATION.FX_NO)),
    otherwise: Yup.string(),
  }),
  senderToReceiverInfo: Yup.string().required(i18n.t(VALIDATION.SENDER_TO_RECEIVER)),
  remarks: Yup.string().required(i18n.t(VALIDATION.REMARKS)),
  customRemarks: Yup.string().when('remarks', {
    is: 'Custom',
    then: Yup.string().required(i18n.t(VALIDATION.CUSTOMTREMARK)),
    otherwise: Yup.string().optional(),
  }),
  isScheduled: Yup.string().required(i18n.t(VALIDATION.SCHUEDULETRANSFER)),

  scheduledDate: Yup.string().when('isScheduled', {
    is: 'Yes',
    then: Yup.string().required(i18n.t(VALIDATION.SCHEDULEDATE)),
    otherwise: Yup.string().optional(),
  }),
  txnCurrency: Yup.string().required(i18n.t(VALIDATION.currency)),
  chargesBorneBy: Yup.string().when(config.CHARGE_BORNE_BY?.toString(), {
    is: 'true',
    then: Yup.string().required(i18n.t(VALIDATION.CHARGESBORNEBY)),
    otherwise: Yup.string(),
  }),
  // chargesBorneBy: Yup.string().required(i18n.t(VALIDATION.CHARGESBORNEBY)),
})

export const EditInternalBeneficiarySchema = Yup.object().shape({
  nickName: Yup.string()
    .required(i18n.t(VALIDATION_MESSAGES.INTERNAL_NICK_NAME))
    .matches(new RegExp('^[a-zA-Z ]*$'), 'Text only'),
  accountNumber: Yup.string().required(i18n.t(VALIDATION.REQUIRED)),
  maxTransferAmount: Yup.string().required(i18n.t(VALIDATION_MESSAGES.INTERNAL_TRANSFER_LIMIT)),
  // beneEMail: Yup.string()
  // .email( i18n.t(VALIDATION.BENEFICIARY_EMAIL_VALID))
  // .required( i18n.t(VALIDATION.BENEFICIARY_EMAIL)),
  // beneMobileNo: Yup.string().required(i18n.t(VALIDATION_MESSAGES.MOBILE_NUMBER_REQUIRED)),
})

export const EditOtherBeneficiarySchema = Yup.object().shape({
  nickName: Yup.string()
    .required(i18n.t(VALIDATION_MESSAGES.INTERNAL_NICK_NAME))
    .matches(new RegExp('^[a-zA-Z ]*$'), 'Text only'),
  accountNumber: Yup.string().required(i18n.t(VALIDATION.REQUIRED)),
  maxTransferAmount: Yup.string().required(i18n.t(VALIDATION.TRANSFERLIMIT)),
  beneEMail: Yup.string()
  .email( i18n.t(VALIDATION.BENEFICIARY_EMAIL_VALID))
  .required( i18n.t(VALIDATION.BENEFICIARY_EMAIL)),
  beneMobileNo: Yup.string().required(i18n.t(VALIDATION_MESSAGES.MOBILE_NUMBER_REQUIRED)),
})

export const RepeatTransferSchema = Yup.object().shape({
  transferAmount: Yup.string().required(i18n.t(VALIDATION.TRANSFERAMOUNT)),
  remarks: Yup.string().required(i18n.t(VALIDATION.REMARKS)),
  customRemarks: Yup.string().when('remarks', {
    is: 'Custom',
    then: Yup.string().required(i18n.t(VALIDATION.CUSTOMTREMARK)),
    otherwise: Yup.string().optional(),
  }),
})
